// @ts-check

import Section from "@/src/shared/components/Section";
import AdminLink from "@/src/shared/components/AdminLink";
import Container from "@/src/shared/components/Container";
import WebLogImage from "@/src/shared/components/WebLogImage";
import Layout from '@/src/shared/components/Layout';
import React, { useContext } from "react";
import WithRelatedResults from "./WithRelatedResults";
import ContentGroupItemsControl from './ContentGroupItems';
import ContentPageContext from "@/src/cms/context/ContentPageContext";
import Error from '@/pages/_error';
import ContentHead from "./ContentHead";
import ContentHero from "./ContentHero";
import ContentLayout from "./ContentLayout";

/**
 * @param {{
 *   children?: import("react").ReactNode;
 *   renderBeforeContent?: () => import("react").ReactNode;
 *   bodyStyle?: any;
 * }} props
 */
export default function ContentPage(props) {
  const { renderBeforeContent, children, bodyStyle } = props;

  const { contentGroupItems } = useContext(ContentPageContext);

  return (
    <ContentLayout>
      {typeof renderBeforeContent === 'function' && renderBeforeContent()}
      <WithRelatedResults bodyStyle={bodyStyle}>
        {contentGroupItems.length > 0 && (
          <Section bgColor="gray">
            <Container>
              <main>
                <ContentGroupItemsControl contentGroupItems={contentGroupItems} />
              </main>
            </Container>
          </Section>
        )}
        {children}
      </WithRelatedResults>
    </ContentLayout>
  )
}